<template>
    <AdminBlock title="Select Customer">
        <template v-slot:options>
            <a :href="generateMoveRoute()" class="btn btn-warning btn-sm">
                <i class="fa fa-fw fa-user"></i>
                Move to different customer
            </a>
        </template>

        <CustomerSelect
            :customer="this.selectedCustomer"
            remove-margin
        />
    </AdminBlock>

    <div class="">
        <div class="row">
            <div :class="{ 'col-lg-4': job.aborted_at_movement_id !== null, 'col-lg-7': job.aborted_at_movement_id === null }">
                <AdminBlock title="Job">
                    <div class="row">
                        <div class="col-md-6 mb-4 mb-md-0">
                            <div class="form-group">
                                <label for="notes">
                                    <strong>
                                        Internal Notes
                                    </strong>
                                </label>
                                <textarea
                                    class="form-control"
                                    rows="8"
                                    placeholder="Internal Notes"
                                    name="notes"
                                    id="notes"
                                    v-model="job.notes"
                                ></textarea>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="initial_driver_notes">
                                    <strong>
                                        Initial Driver Notes
                                    </strong>
                                </label>
                                <textarea
                                    class="form-control"
                                    rows="8"
                                    placeholder="These notes will appear before any other notes entered later for all movements in the job."
                                    name="initial_driver_notes"
                                    id="initial_driver_notes"
                                    v-model="job.initial_driver_notes"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </AdminBlock>
            </div>

            <div
                v-if="job.aborted_at_movement_id !== null"
                class="col-lg-4"
            >
                <AdminBlock title="Aborted Reason">
                    <div class="form-group">
                        <label>
                            <strong>
                                Driver Reason
                            </strong>
                        </label>
                        <p>
                            {{ internalAbortedDriverReason }}
                        </p>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>
                                Admin Reason
                            </strong>
                        </label>
                        <textarea
                            v-model="job.aborted_admin_reason"
                            class="form-control"
                            rows="4"
                            placeholder="Admin Reason"
                        ></textarea>
                    </div>
                </AdminBlock>
            </div>

            <div :class="{ 'col-lg-4': job.aborted_at_movement_id !== null, 'col-lg-5': job.aborted_at_movement_id === null }">
                <AdminBlock title="Contract">
                    <fieldset class="">

                        <ContractSelect
                            v-model="selectedContract"
                            :customer="this.selectedCustomer"
                            :contract="this.selectedContract"
                        />

                        <div class="form-group mb-4">
                            <label for="client_ref">
                                <strong>
                                    Purchase Order (Client Ref)
                                </strong>
                            </label>
                            <input class="form-control" placeholder="Client ref" name="client_ref" type="text" id="client_ref" v-model="clientRef">
                        </div>

                        <div class="form-group">
                            <div class="d-flex align-items-end">
                                <div class="me-4" style="flex: auto;">
                                    <ContactSelect
                                        v-model="selectedContact"
                                        title="Contact"
                                        :customer="selectedCustomer"
                                        :contact="job.contact"
                                        :required="true"
                                        remove-margin
                                    />
                                </div>
                                <div class="">
                                    <button class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#contract_contact_modal" >
                                        Create
                                    </button>

                                    <ContactModal
                                        :selected-customer="selectedCustomer"
                                        identifier="contract"
                                        :user="user"
                                        @contact-created=""
                                    />

                                </div>
                            </div>
                        </div>
                    </fieldset>

                </AdminBlock>
            </div>
        </div>

        <div class="row">

            <div class="col-lg-6">
                <AdminBlock title="Collection">

                    <fieldset v-if="canEditRoute" class="">

                        <div class="form-group mb-4">
                            <label for="collection_date">
                                <strong>
                                    Collection Date
                                </strong>
                            </label>
                            <div class="input-group datetime collection-date">
                                    <span class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                <input
                                    class="form-control js-flatpickers"
                                    placeholder="yyyy-mm-dd"
                                    id="collection_date"
                                    name="collection_date"
                                    v-model="collectionDate"
                                    type="date"
                                >
                            </div>
                        </div>

                        <div class="form-group">

                            <label>
                                <strong>
                                    Collection Time
                                </strong>
                            </label>

                            <div class="input-group align-items-center">

                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        Any
                                    </label>
                                    <input
                                        name="collection_time"
                                        v-model="collectionTime"
                                        value="Any"
                                        checked
                                        class="form-check-input"
                                        type="radio"
                                        id="form_collection_time"
                                    >
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        AM
                                    </label>
                                    <input
                                        name="collection_time"
                                        v-model="collectionTime"
                                        value="AM"
                                        class="form-check-input"
                                        type="radio"
                                        id="form_collection_time"
                                    >
                                </div>

                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        PM
                                    </label>
                                    <input
                                        name="collection_time"
                                        v-model="collectionTime"
                                        value="PM"
                                        class="form-check-input"
                                        type="radio"
                                        id="form_collection_time"
                                    >
                                </div>

                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        Evening
                                    </label>
                                    <input
                                        name="collection_time"
                                        v-model="collectionTime"
                                        value="Evening"
                                        class="form-check-input"
                                        type="radio"
                                        id="form_collection_time"
                                    >
                                </div>

                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        Night
                                    </label>
                                    <input
                                        name="collection_time"
                                        v-model="collectionTime"
                                        value="Night"
                                        class="form-check-input"
                                        type="radio"
                                        id="form_collection_time"
                                    >
                                </div>

                                <div class="form-check form-check-inline d-flex align-items-center">
                                    <input
                                        name="collection_time"
                                        v-model="collectionTime"
                                        value="Specific"
                                        class="form-check-input me-2"
                                        style="margin-top: -2px;"
                                        type="radio"
                                    >
                                    <input
                                        class="form-control flatpicker-time-only"
                                        style="margin-top: -2px;"
                                        placeholder="hh:ii"
                                        id="collection_time_specific"
                                        maxlength="5"
                                        name="collection_time_specific"
                                        ref="collectionTimeSpecific"
                                        v-model="collectionTimeSpecific"
                                    >
                                </div>

                            </div>

                        </div>

                        <div class="form-group mb-4">

                            <label>
                                <strong>
                                    Collection Location
                                </strong>
                            </label>

                            <GoogleMap
                                map-for="collection"
                                :location="collectionLocation"
                                :selected-customer="selectedCustomer"
                                @location-changed="updateCollectionLocation"
                            />

                        </div>

                        <div class="form-group mb-4">
                            <label for="collection_company">
                                <strong>
                                    Collection Company
                                </strong>
                            </label>
                            <input
                                class="form-control"
                                placeholder="Name of company if different from Customer"
                                name="collection_company"
                                v-model="collectionCompany"
                                type="text"
                                id="collection_company"
                            >
                        </div>

                        <div class="form-group">
                            <div class="d-flex align-items-end">
                                <div class="me-4" style="flex: auto;">

                                    <ContactSelect
                                        v-model="selectedCollectionContact"
                                        title="Collection Contact"
                                        :customer="selectedCustomer"
                                        :contact="job.collection_contact"
                                        remove-margin
                                    />

                                </div>

                                <div class="">
                                    <button class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#collection_contact_modal">
                                        Create
                                    </button>

                                    <ContactModal
                                        :selected-customer="selectedCustomer"
                                        identifier="collection"
                                        :user="user"
                                        @contact-created=""
                                    />
                                </div>

                            </div>

                        </div>

                    </fieldset>
                    <fieldset v-else>
                        <p class="mb-0">
                            <strong>
                                Location
                            </strong>
                            {{ collectionLocation }}
                        </p>
                        <p class="mb-0">
                            <strong>
                                Date
                            </strong>
                            {{ formatDate(collectionDate) }}
                            <TimeLabel :time="collectionTime" />
                        </p>
                    </fieldset>

                </AdminBlock>
            </div>

            <div class="col-lg-6">
                <AdminBlock title="Delivery">
                    <fieldset v-if="canEditRoute" class="">
                        <div class="form-group mb-4">
                            <label for="delivery_date">
                                <strong>
                                    Delivery Date
                                </strong>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </span>
                                <input class="form-control js-flatpickers"
                                       placeholder="yyyy-mm-dd"
                                       id="delivery_date"
                                       name="delivery_date"
                                       v-model="deliveryDate"
                                       type="date"
                                >
                            </div>
                        </div>
                        <div class="form-group ">

                            <label>
                                <strong>
                                    Delivery Time
                                </strong>
                            </label>

                            <div class="input-group align-items-center">
                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        Any
                                    </label>
                                    <input
                                        name="delivery_time"
                                        v-model="deliveryTime"
                                        value="Any"
                                        class="form-check-input"
                                        type="radio"
                                        id="form_delivery_time"
                                    >
                                </div>

                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        AM
                                    </label>
                                    <input
                                        name="delivery_time"
                                        v-model="deliveryTime"
                                        value="AM"
                                        class="form-check-input"
                                        type="radio"
                                        id="form_delivery_time"
                                    >
                                </div>

                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        PM
                                    </label>
                                    <input
                                        name="delivery_time"
                                        v-model="deliveryTime"
                                        value="PM"
                                        class="form-check-input"
                                        type="radio"
                                        id="form_delivery_time"
                                    >
                                </div>

                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        Evening
                                    </label>
                                    <input
                                        name="delivery_time"
                                        v-model="deliveryTime"
                                        value="Evening"
                                        class="form-check-input"
                                        type="radio"
                                        id="form_delivery_time"
                                    >
                                </div>

                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        Night
                                    </label>
                                    <input
                                        name="delivery_time"
                                        v-model="deliveryTime"
                                        value="Night"
                                        class="form-check-input"
                                        type="radio"
                                        id="form_delivery_time"
                                    >
                                </div>

                                <div class="form-check form-check-inline d-flex align-items-center">
                                    <input
                                        name="delivery_time"
                                        v-model="deliveryTime"
                                        value="Specific"
                                        class="form-check-input me-2"
                                        style="margin-top: -2px;"
                                        type="radio"
                                        :checked="isSpecificTime(deliveryTime)"
                                    >
                                    <input
                                        class="form-control flatpicker-time-only"
                                        style="margin-top: -2px;"
                                        placeholder="hh:ii"
                                        id="delivery_time_specific"
                                        maxlength="5"
                                        name="delivery_time_specific"
                                        ref="deliveryTimeSpecific"
                                        v-model="deliveryTimeSpecific"
                                    >
                                </div>

                            </div>

                        </div>
                        <div class="form-group mb-4">

                            <label>
                                <strong>
                                    Delivery Location
                                </strong>
                            </label>

                            <GoogleMap
                                map-for="delivery"
                                :location="deliveryLocation"
                                :selected-customer="selectedCustomer"
                                @location-changed="updateDeliveryLocation"
                            />

                        </div>
                        <div class="form-group mb-4">
                            <label>
                                <strong>
                                    Delivery Company
                                </strong>
                            </label>
                            <input
                                class="form-control"
                                placeholder="Name of company if different from Customer"
                                name="delivery_company"
                                v-model="deliveryCompany"
                                type="text"
                                id="delivery_company"
                            >
                        </div>
                        <div class="form-group">
                            <div class="d-flex align-items-end">
                                <div class="me-4" style="flex: auto;">
                                    <ContactSelect
                                        title="Delivery Contact"
                                        :customer-id="selectedCustomer ?? null"
                                        v-model="selectedDeliveryContact"
                                        :contact="job.delivery_contact"
                                        @update-contact="updateDeliveryContact"
                                        remove-margin
                                    />
                                </div>
                                <div class="">
                                    <button
                                        class="btn btn-secondary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#delivery_contact_modal"
                                    >
                                        Create
                                    </button>
                                </div>
                                <ContactModal
                                    :selected-customer="selectedCustomer"
                                    identifier="delivery"
                                    :user="user"
                                    @contact-created=""
                                />
                            </div>
                        </div>
                    </fieldset>
                    <fieldset v-else>
                        <p class="mb-0">
                            <strong>
                                Location
                            </strong>
                            {{ deliveryLocation }}
                        </p>
                        <p class="mb-0">
                            <strong>
                                Date
                            </strong>
                            {{ formatDate(deliveryDate) }}
                        </p>
                    </fieldset>

                </AdminBlock>
            </div>

        </div>

        <div class="row">

            <div class="col-lg-6">

                <AdminBlock title="Route">

                    <estimate-route
                        :collection="{
                                lat: this.collectionLatitude,
                                lng: this.collectionLongitude
                            }"
                        :delivery="{
                                lat: this.deliveryLatitude,
                                lng: this.deliveryLongitude
                            }"
                        :mileage="mileage"
                        @update-mileage="updateMileage"
                    />

                </AdminBlock>

            </div>

            <div class="col-lg-6">
                <div class="row">
                    <div class="col-12">

                        <AdminBlock title="Vehicle">

                            <div class="form-group mb-2">
                                <div class="d-flex align-items-end">
                                    <div class="me-4" style="flex: auto">

                                        <VehicleSelect
                                            v-model="selectedVehicle"
                                            :customer="this.selectedCustomer"
                                            :vehicle="this.selectedVehicle"
                                            remove-margin
                                            :required="true"
                                        />

                                    </div>
                                    <div class="">
                                            <span class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#createVehicleModal">
                                                Create
                                            </span>

                                        <VehicleModal
                                            :customer="this.selectedCustomer"
                                            @vehicle-created="vehicle => { this.selectedVehicle = vehicle.data }"
                                        />
                                    </div>
                                </div>
                            </div>

                        </AdminBlock>

                    </div>

                    <div class="col-12">
                        <AdminBlock title="Price">
                            <RoutePrice
                                :job_id="this.job.id"
                                :contract_id="this.selectedContract?.id"
                                :vehicle_id="this.selectedVehicle?.id"
                                :mileage="this.mileage"
                                :price="this.price.price"
                                @update-price="updatePrice"
                                @update-price-only="updatePriceOnly"
                                @update-adblue="updateAdblue"
                                @update-fuel="updateFuel"
                            />
                        </AdminBlock>
                    </div>

                </div>
            </div>

        </div>

        <div class="col-12">
            <AdminBlock>
                <div class="d-flex justify-content-end">
                    <a href="" class="btn btn-sm btn-secondary me-2">
                        View All Jobs
                    </a>

                    <button @click="updateJobRequest" id="create_contact_form_save" class="btn btn-sm btn-primary">
                        Save
                    </button>

                </div>
            </AdminBlock>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import flatpickr from "flatpickr";
import Swal from 'sweetalert2';
import VSelect from 'vue-select';
import AdminBlock from '@/components/movements/components/AdminBlock.vue';
import AdminToast from '@/components/movements/components/AdminToast.vue';
import ContactModal from "@/components/movements/components/ContactModal.vue";
import CustomerSelect from "@/components/movements/components/CustomerSelect.vue";
import ContractSelect from "@/components/movements/components/ContractSelect.vue";
import ContactSelect from "@/components/movements/components/ContactSelect.vue";
import EstimateRoute from "@/components/movements/components/EstimateRoute.vue";
import GoogleMap from "@/components/movements/components/GoogleMap.vue";
import RoutePrice from "@/components/movements/components/RoutePrice.vue";
import TimeLabel from "@/components/movements/components/TimeLabel.vue";
import VehicleModal from "@/components/movements/components/VehicleModal.vue";
import VehicleSelect from "@/components/movements/components/VehicleSelect.vue";

export default {

    components: {
        AdminBlock,
        AdminToast,
        ContactSelect,
        ContractSelect,
        CustomerSelect,
        ContactModal,
        EstimateRoute,
        TimeLabel,
        RoutePrice,
        GoogleMap,
        VehicleModal,
        VehicleSelect,
        VSelect,
    },

    props: {
        user: {
            type: Object,
        },
        job: {
            type: Object,
            default: null,
            required: true
        },
        canEditRoute: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            selectedCustomer: this.job.customer ?? null,
            selectedContract: this.job.contract ?? null,
            clientRef: this.job.client_ref,
            selectedContact: this.job.contact ?? null,

            notes: this.job.notes,
            initialDriverNotes: this.job.initial_driver_notes,

            internalAbortedDriverReason: this.job.aborted_driver_reason ?? null,

            collectionDate: this.job.collection_date ?? null,
            collectionTime: this.job.collection_time ?? null,
            collectionTimeSpecific: '',
            collectionLocation: this.job.collection_location ?? null,
            collectionLocale: this.job.collection_locale ?? null,
            collectionLatitude: this.job.collection_lat ?? null,
            collectionLongitude: this.job.collection_lng ?? null,
            collectionCompany: this.job.collection_company ?? null,
            selectedCollectionContact: this.job.collection_contact ?? null,

            deliveryDate: this.job.delivery_date ?? null,
            deliveryTime: this.job.delivery_time ?? null,
            deliveryTimeSpecific: '',
            deliveryLocation: this.job.delivery_location ?? null,
            deliveryLocale: this.job.delivery_locale ?? null,
            deliveryLatitude: this.job.delivery_lat ?? null,
            deliveryLongitude: this.job.delivery_lng ?? null,
            deliveryCompany: this.job.delivery_company ?? null,
            selectedDeliveryContact: this.job.delivery_contact ?? null,

            mileage: this.job.mileage,
            selectedVehicle: this.job.vehicle ?? null,

            price: this.job.price,

            rateVehicletypeId: null,
            rateMinimumPrice: null,
            rateMinimumPriceMileage: null,
            ratePricePerMileAfterMin: null,

            priceIncludesFuel: this.job.price_includes_fuel,
            priceIncludesAdblue: this.job.price_includes_adblue,
        }
    },

    mounted() {

        flatpickr('.js-flatpickers', {
            dateFormat: "Y-m-d",
            enableTime: false,
            altInput: true,
        });

        flatpickr('.flatpicker-time-only', {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            time_24hr: true,
            altInput: true,
        });

        if (this.isSpecificTime(this.collectionTime)) {
            this.$refs.collectionTimeSpecific._flatpickr.setDate(this.collectionTime);
            this.collectionTime = 'Specific';
        }

        if (this.isSpecificTime(this.deliveryTime)) {
            this.$refs.deliveryTimeSpecific._flatpickr.setDate(this.deliveryTime);
            this.deliveryTime = 'Specific';
        }

    },

    methods: {

        formatDate(dateString) {
            const date = new Date(dateString);
            const formatter = new Intl.DateTimeFormat('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
            return formatter.format(date);
        },

        updatePrice(values) {
            this.price = values.price;
            this.rateMinimumPrice = values.rate.minimum_price;
            this.rateMinimumPriceMileage = values.rate.minimum_price_mileage;
            this.ratePricePerMileAfterMin = values.rate.price_per_mile_after_min;
            this.rateVehicletypeId = values.rate.vehicletype_id;
        },

        updatePriceOnly(newPrice) {
            this.price = newPrice;
        },

        updateAdblue(value) {
            this.priceIncludesAdblue = value;
        },

        updateFuel(value) {
            this.priceIncludesFuel = value;
        },

        generateMoveRoute() {
            return route('movements.jobs.move.index', { job: this.job.id });
        },

        updateMileage(newMileage) {
            this.mileage = newMileage;
        },

        updateDeliveryLocation(values) {

            if (values.location !== null && values.location !== '') {
                this.deliveryLocation = values.location;
            }

            if (values.latitude !== null && values.longitude !== null) {
                this.deliveryLatitude = values.latitude;
                this.deliveryLongitude = values.longitude;
            }

            if (values.locale !== null && values.locale !== '') {
                this.deliveryLocale = values.locale;
            }

        },

        updateCollectionLocation(values) {

            if (values.location !== null && values.location !== '') {
                this.collectionLocation = values.location;
            }

            if (values.latitude !== null && values.longitude !== null) {
                this.collectionLatitude = values.latitude;
                this.collectionLongitude = values.longitude;
            }

            if (values.locale !== null && values.locale !== '') {
                this.collectionLocale = values.locale;
            }

        },

        isSpecificTime(time) {
            return time !== 'Any' &&
                time !== 'AM' &&
                time !== 'PM' &&
                time !== 'Evening' &&
                time !== 'Night';
        },

        updateJobRequest () {

            const data = new FormData();

            // This is organised in the order they appear on the page
            data.append('job_id', this.job.id);

            data.append('customer_id', this.selectedCustomer.id);
            data.append('notes', this.notes);
            data.append('initial_driver_notes', this.initialDriverNotes);

            data.append('aborted_admin_reason', this.internalAbortedDriverReason);

            data.append('contract_id', this.selectedContract.id);
            data.append('client_ref', this.clientRef);
            data.append('contact_id', this.selectedContact.id);

            data.append('collection_date', this.collectionDate);

            if (this.collectionTime === 'Specific') {
                data.append('collection_time', this.collectionTimeSpecific);
            } else {
                data.append('collection_time', this.collectionTime);
            }

            data.append('collection_location', this.collectionLocation);
            data.append('collection_lat', this.collectionLatitude);
            data.append('collection_lng', this.collectionLongitude);
            data.append('collection_locale', this.collectionLocale);

            data.append('collection_company', this.collectionCompany);
            data.append('collectioncontact_id', this.selectedCollectionContact.id);

            data.append('delivery_date', this.deliveryDate);

            if (this.deliveryTime === 'Specific') {
                data.append('delivery_time', this.collectionTimeSpecific);
            } else {
                data.append('delivery_time', this.deliveryTime);
            }

            data.append('delivery_location', this.deliveryLocation);
            data.append('delivery_lat', this.deliveryLatitude);
            data.append('delivery_lng', this.deliveryLongitude);
            data.append('delivery_locale', this.deliveryLocale);

            data.append('delivery_company', this.deliveryCompany);
            data.append('deliverycontact_id', this.selectedDeliveryContact.id);

            data.append('mileage', this.mileage);
            data.append('vehicle_id', this.selectedVehicle?.id);
            data.append('price', this.price);
            data.append('price_includes_fuel', this.priceIncludesFuel);
            data.append('price_includes_adblue', this.priceIncludesAdblue);

            axios.post( route('api.movements.jobs.update'), data )
                .then(response => {

                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'success',
                        title: 'Job Updated',
                        text: response.data.message,
                        confirmButtonText: 'Dismiss',
                        confirmButtonColor: '#28a745',
                        width: '600px',
                        timer: 5000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer);
                            toast.addEventListener('mouseleave', Swal.resumeTimer);
                        },
                    })
                        .then(() => {
                            window.location.href = response.data.redirect_url;
                        });

                })
                .catch(error => {

                    if (error.response?.data?.errors) {

                        const errorMessages = error.response.data.errors;

                        let allErrors = '';

                        Object.entries(errorMessages).forEach(([, messages]) => {
                            messages.forEach(errorMessage => {
                                allErrors += '<p class="mb-0">' + errorMessage + '</p>';
                            });
                        });

                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'error',
                            title: 'Error Updating Job',
                            html: allErrors,
                            confirmButtonText: 'Dismiss',
                            confirmButtonColor: '#dc3545 ',
                            width: '600px',
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer);
                                toast.addEventListener('mouseleave', Swal.resumeTimer);
                            },
                        });
                    }
                });
        },
    },
}

</script>
